import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { LegalPageShell, useLegalConfig } from "../components/LegalPageShell";
import { TERMS_CONTENT } from "../legal/legalContent";

export default function TermsPage() {
  const { language } = useLanguage();
  const cfg = useLegalConfig();
  const content = cfg ? (TERMS_CONTENT[language] || TERMS_CONTENT.es)(cfg) : null;
  return <LegalPageShell testId="terms-page" content={content} />;
}
